import { render, staticRenderFns } from "./TiptapAlert.vue?vue&type=template&id=66668080"
import script from "./TiptapAlert.vue?vue&type=script&lang=js"
export * from "./TiptapAlert.vue?vue&type=script&lang=js"
import style0 from "./TiptapAlert.vue?vue&type=style&index=0&id=66668080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VIcon,VRow})
